import styled from "styled-components";

const ShareRoomStyled = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;

  .copyUrl {
    height: 3rem;
  }
`;

export default ShareRoomStyled;
